import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  closeMsg,
  fromNowOnYouWillLoginMsg,
  t,
  youCanEditElisaIdDetailsMsg,
  yourElisaIdIsNowInUseMsg,
} from '../../common/i18n/index.js';
import { Modal } from '../Modal/Modal.js';
import { ModalButtons } from '../Modal/ModalButtons.js';

import './ElisaIdMigrationConfirmation.scss';

export interface ElisaIdMigrationConfirmationProps {
  userEmail: string;
  onClose: () => void;
}

export const ElisaIdMigrationConfirmation = ({ userEmail, onClose }: ElisaIdMigrationConfirmationProps) => {
  return (
    <Modal closeable size="m" onClose={onClose} className="of-elisa-id-migration-confirmation__dialog">
      <div className={`of-elisa-id-migration-confirmation ${dsClass.DISPLAY_FLEX}`}>
        <div className="login-icon" />
        <h3 className={`${dsClass.MARGIN_0}`}>{t.OXXR(yourElisaIdIsNowInUseMsg)}</h3>
        <p>
          {t.MD77(fromNowOnYouWillLoginMsg)} <strong>{userEmail}</strong>
        </p>
        <p>{t.BBJW(youCanEditElisaIdDetailsMsg)}</p>
      </div>
      <ModalButtons>
        <CL.Button color="primary" size="l" onClick={onClose}>
          {t.WOYD(closeMsg)}
        </CL.Button>
      </ModalButtons>
    </Modal>
  );
};
